import React from "react";
function NewsDetailContent({News}) {
    return (
        <div className="newsDetailContent">
            <div className="bannerNews">
                <img className="img-fluid" src={News.image} alt="" />
            </div>
            <h1 className="title">
                {News.title}
            </h1>
            <div className="time">{News.time}</div>
            <div className="content">{News.content}</div>
        </div>
    );
}
export default NewsDetailContent;